import { request } from "@/api";
import type { OfferItem, IFetchOffersParams } from "@/shared/types";

interface FetchOffersParams extends IFetchOffersParams {
  limit: number;
  offset: number;
  signal?: AbortSignal;
}

export const fetchOffers = async (
  params: FetchOffersParams,
  signal?: AbortSignal
) => {
  return request<OfferItem[]>("/offers", {
    params,
    signal,
  });
};
export const fetchOffersByUserId = async (
  userId: string,
  params?: FetchOffersParams
) => {
  return request<OfferItem[]>(`/user/${userId}/offers`, {
    params,
  });
};

interface FetchUserOffersParams {
  limit: number;
  offset: number;
}

export const fetchUserOffers = async (params: FetchUserOffersParams) => {
  return request<OfferItem[]>("/offers/my", {
    params,
  });
};

interface FormData {
  offerId?: number | null;
  type: string;
  currencyIn: string;
  currencyOut: string;
  priceType: string;
  priceVal: number;
  userPaymentOptions: number[];
  minLimit: string;
  maxLimit: string;
  termsOfUse: string;
  isActive: boolean;
}

export const createOffer = async (data: FormData) => {
  return request<OfferItem>("/offers", {
    method: "POST",
    body: data,
  });
};

export const editOffer = async (data: FormData) => {
  return request<OfferItem>(`/offers/${data.offerId}`, {
    method: "POST",
    body: data,
  });
};

export const deleteOffer = async (offerId: number) => {
  return request(`/offers/${offerId}`, {
    method: "DELETE",
  });
};
